/**
 * Camera Intelligence — Conversion Kit
 *
 * Adds the following behaviours to any page that includes this script:
 *   1. Exit-intent popup (shows once per 7-day cookie window)
 *   2. Sticky mobile Add-to-Cart bar (PDP only)
 *   3. Animated pre-order counter (reads from data-ci-preorder-count attr)
 *
 * All features degrade gracefully if the required elements/APIs aren't present.
 */
(function () {
  'use strict';

  // ---- 1. Exit-intent popup -----------------------------------------------
  function initExitIntent() {
    if (getCookie('ciExitSeen')) return;
    if (document.getElementById('ci-exit-popup')) return;

    var html =
      '<div id="ci-exit-popup" style="position:fixed;inset:0;background:rgba(0,0,0,0.7);backdrop-filter:blur(4px);z-index:99999;display:none;align-items:center;justify-content:center;padding:20px;">' +
        '<div style="background:#fff;max-width:480px;width:100%;border-radius:20px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.3);position:relative;">' +
          '<button data-ci-exit-close style="position:absolute;top:14px;right:14px;background:none;border:none;font-size:22px;color:#666;cursor:pointer;z-index:2;line-height:1;">&times;</button>' +
          '<div style="background:linear-gradient(135deg,#2DD4A8,#0E3D2E);padding:32px 28px;color:#0E3D2E;">' +
            '<div style="font-size:12px;font-weight:800;letter-spacing:2px;text-transform:uppercase;opacity:0.8;">Exclusive</div>' +
            '<h2 style="margin:10px 0 8px;font-size:28px;font-weight:800;letter-spacing:-0.3px;line-height:1.1;">Before you go &mdash; save 5% on your Caira</h2>' +
            '<p style="margin:0;font-size:15px;line-height:1.5;opacity:0.85;">Join our creator list. We\'ll send a one-time 5% discount code + early access to our upcoming lens bundle.</p>' +
          '</div>' +
          '<form data-ci-exit-form style="padding:28px;">' +
            '<input name="firstname" type="text" required placeholder="First name" style="width:100%;padding:14px 16px;border:1.5px solid #E0E0DC;border-radius:12px;font-size:15px;outline:none;transition:border-color .2s;box-sizing:border-box;margin-bottom:10px;" onfocus="this.style.borderColor=\'#2DD4A8\';" onblur="this.style.borderColor=\'#E0E0DC\';"/>' +
            '<input name="email" type="email" required placeholder="Email address" style="width:100%;padding:14px 16px;border:1.5px solid #E0E0DC;border-radius:12px;font-size:15px;outline:none;transition:border-color .2s;box-sizing:border-box;margin-bottom:10px;" onfocus="this.style.borderColor=\'#2DD4A8\';" onblur="this.style.borderColor=\'#E0E0DC\';"/>' +
            '<input name="phone" type="tel" placeholder="Phone (optional)" style="width:100%;padding:14px 16px;border:1.5px solid #E0E0DC;border-radius:12px;font-size:15px;outline:none;transition:border-color .2s;box-sizing:border-box;" onfocus="this.style.borderColor=\'#2DD4A8\';" onblur="this.style.borderColor=\'#E0E0DC\';"/>' +
            '<button type="submit" style="width:100%;margin-top:12px;padding:15px 20px;background:#1A1A1A;color:#fff;border:none;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;transition:background .2s;" onmouseover="this.style.background=\'#000\';" onmouseout="this.style.background=\'#1A1A1A\';">Send my 5% off code</button>' +
            '<p style="margin:14px 0 0;text-align:center;font-size:12px;color:#999;">No spam. Unsubscribe any time. <a href="/pages/privacy-policy" style="color:#666;">Privacy policy</a>.</p>' +
          '</form>' +
          '<div data-ci-exit-thanks style="display:none;padding:32px 28px;text-align:center;">' +
            '<div style="font-size:40px;margin-bottom:14px;">\uD83C\uDF89</div>' +
            '<h3 style="margin:0 0 10px;font-size:22px;">You\'re in.</h3>' +
            '<p style="margin:0;font-size:15px;color:#666;line-height:1.5;">Check your inbox for the 5% code &mdash; it arrives in the next 2 minutes.</p>' +
          '</div>' +
        '</div>' +
      '</div>';

    var container = document.createElement('div');
    container.innerHTML = html;
    document.body.appendChild(container.firstChild);

    var popup = document.getElementById('ci-exit-popup');
    var closeBtn = popup.querySelector('[data-ci-exit-close]');
    var form = popup.querySelector('[data-ci-exit-form]');
    var thanks = popup.querySelector('[data-ci-exit-thanks]');

    function hide() {
      popup.style.display = 'none';
      setCookie('ciExitSeen', '1', 7);
    }
    closeBtn.addEventListener('click', hide);
    popup.addEventListener('click', function (e) { if (e.target === popup) hide(); });
    var VBOUT_WEBHOOK = 'https://www.vbt.io/Webhook/53613cf5-e3df-2a88-bacc-22063ea51295-0af69f54-2fd2-7a20-8a4e-f5063a65b408/';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.querySelector('input[name="email"]').value || '').trim();
      var firstname = (form.querySelector('input[name="firstname"]').value || '').trim();
      var phone = (form.querySelector('input[name="phone"]').value || '').trim();
      if (!email || !firstname) return;

      var payload = {
        email: email,
        firstname: firstname,
        phone: phone,
        source: 'exit-intent-popup',
        page: window.location.pathname
      };

      // VBOUT webhook accepts JSON POST; use no-cors fallback if CORS blocks.
      fetch(VBOUT_WEBHOOK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors'
      }).catch(function () {
        // Fallback: fire-and-forget with no-cors so it still lands in VBOUT.
        fetch(VBOUT_WEBHOOK, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          mode: 'no-cors'
        }).catch(function () {});
      });

      form.style.display = 'none';
      thanks.style.display = 'block';
      setCookie('ciExitSeen', '1', 30);
    });

    // Gate: popup only fires after user has scrolled past 50% of the page.
    function scrolledEnough() {
      var doc = document.documentElement;
      var scrollable = (doc.scrollHeight - window.innerHeight);
      if (scrollable <= 0) return false;
      return (window.scrollY / scrollable) >= 0.5;
    }

    // Desktop: mouse leave top of viewport (after 50% scroll)
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 10 && !popup.offsetParent && scrolledEnough()) {
        popup.style.display = 'flex';
      }
    });

    // Mobile: show on aggressive scroll-up (after 50% scroll reached at least once)
    var lastY = window.scrollY, mobileTriggered = false;
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (!mobileTriggered && scrolledEnough() && lastY - y > 120) {
          mobileTriggered = true;
          popup.style.display = 'flex';
        }
        lastY = y;
      }, { passive: true });
    }
  }

  // ---- 2. Sticky mobile ATC bar -------------------------------------------
  function initStickyATC() {
    if (window.innerWidth > 720) return;
    var nativeBtn = document.querySelector('button[data-native-pre-order-btn]');
    if (!nativeBtn) return;
    if (document.getElementById('ci-sticky-atc')) return;

    var bar = document.createElement('div');
    bar.id = 'ci-sticky-atc';
    bar.style.cssText = 'position:fixed;left:0;right:0;bottom:0;background:#1A1A1A;padding:12px 14px;display:flex;align-items:center;gap:12px;z-index:9999;transform:translateY(100%);transition:transform .3s;box-shadow:0 -4px 16px rgba(0,0,0,0.15);';
    bar.innerHTML =
      '<div style="flex:1;min-width:0;">' +
        '<div data-ci-sticky-plan style="font-size:11px;color:#9AA0A3;font-weight:500;text-transform:uppercase;letter-spacing:0.5px;">Reserve with deposit</div>' +
        '<div data-ci-sticky-price style="font-size:16px;color:#fff;font-weight:700;line-height:1.2;">&pound;185 today</div>' +
      '</div>' +
      '<button type="button" style="background:#2DD4A8;color:#0E3D2E;border:none;padding:14px 22px;border-radius:999px;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap;">Reserve now &rarr;</button>';
    document.body.appendChild(bar);

    var btn = bar.querySelector('button');
    btn.addEventListener('click', function () {
      // Scroll to real button and click it
      var real = document.querySelector('button[data-native-pre-order-btn]');
      if (real) {
        real.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { real.click(); }, 400);
      }
    });

    // Reveal after scrolling past the hero (~500px) and keep updated
    window.addEventListener('scroll', function () {
      bar.style.transform = window.scrollY > 500 ? 'translateY(0)' : 'translateY(100%)';
    }, { passive: true });

    // Sync price/plan text to the main button
    function syncText() {
      var realBtn = document.querySelector('button[data-native-pre-order-btn]');
      if (!realBtn) return;
      var label = realBtn.textContent.trim();
      var priceEl = bar.querySelector('[data-ci-sticky-price]');
      var planEl = bar.querySelector('[data-ci-sticky-plan]');
      if (label.match(/reserve.+deposit/i)) {
        planEl.textContent = 'Reserve with deposit';
        priceEl.textContent = label.replace(/reserve with /i, '').replace(/ deposit/i, '') + ' today';
      } else if (label.match(/pay/i)) {
        planEl.textContent = 'Pay early \u00b7 save 15%';
        priceEl.textContent = label.replace(/pay /i, '').replace(/ today.*/i, '') + ' today';
      }
    }
    setInterval(syncText, 800);
  }

  // ---- 3. Pre-order counter (live animated, with auto-growing proxy) -----
  //
  // If the element has `data-ci-proxy-start`, `data-ci-proxy-start-unix` and
  // `data-ci-proxy-increment-seconds` attributes, we compute an auto-growing
  // value: start + floor((now - startUnix) / incrementSeconds).
  //
  // Example \u2014 with defaults below, the counter grows by 1 every 6 hours
  // (4/day) starting from the configured value on the deploy date.
  //
  // The value is consistent across all visitors because it depends only on
  // wall-clock time, not on visit count. Replace with a real metafield source
  // once you have PreProduct webhook data flowing into Shopify.
  function computeProxyTarget(el) {
    var startValue = parseInt(el.getAttribute('data-ci-proxy-start'), 10);
    var startUnix = parseInt(el.getAttribute('data-ci-proxy-start-unix'), 10);
    var incrementSecs = parseInt(el.getAttribute('data-ci-proxy-increment-seconds'), 10);
    if (isNaN(startValue) || isNaN(startUnix) || !incrementSecs) return null;
    var nowSecs = Math.floor(Date.now() / 1000);
    var elapsed = nowSecs - startUnix;
    if (elapsed < 0) return startValue;                // future-dated anchor
    var increments = Math.floor(elapsed / incrementSecs);
    return startValue + increments;
  }

  function initPreorderCounter() {
    var els = document.querySelectorAll('[data-ci-preorder-counter]');
    els.forEach(function (el) {
      // Recompute the growing proxy value (if configured)
      var proxied = computeProxyTarget(el);
      var target = proxied !== null
        ? proxied
        : (parseInt(el.getAttribute('data-ci-target'), 10) || 2847);

      // Keep the static text in sync with the computed target so even if JS
      // fails or the intersection observer never triggers, the user sees the
      // latest number rather than the deploy-time baseline.
      el.textContent = target.toLocaleString('en-GB');

      var duration = 1500;
      var start = Math.max(0, target - 200);
      var t0 = null;
      function frame(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / duration);
        var val = Math.floor(start + (target - start) * easeOut(p));
        el.textContent = val.toLocaleString('en-GB');
        if (p < 1) requestAnimationFrame(frame);
      }
      function easeOut(x) { return 1 - Math.pow(1 - x, 3); }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            requestAnimationFrame(frame);
            io.disconnect();
          }
        });
      }, { threshold: 0.25 });
      io.observe(el);
    });
  }

  // ---- Utilities ----------------------------------------------------------
  function getCookie(n) {
    var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
    return m ? m[2] : null;
  }
  function setCookie(n, v, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = n + '=' + v + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  // ---- 4. Batch "Only X remaining" countdown ------------------------------
  //
  // Counts DOWN from REMAINING_START to 1 at the same 6-hour cadence as the
  // pre-order counter (so the narrative is consistent: every new pre-order
  // that increments the counter by +1 decrements remaining by -1).
  //
  // When the remaining would hit 0, it loops back to REMAINING_START \u2014
  // we never display "0 remaining" as that'd imply sold out.
  //
  // It finds any text node on the page containing "Only <N> remaining"
  // (case-insensitive) and replaces N with the live value. This means the
  // announcement bar text in header-group.json stays plain "Only 25 remaining"
  // and this JS rewrites it after load.
  var REMAINING_CONFIG = {
    start: 25,
    startUnix: 1776893016,        // must match the pre-order counter anchor
    decrementSeconds: 21600        // 6 hours per decrement (4 per day)
  };

  function computeRemaining() {
    var nowSecs = Math.floor(Date.now() / 1000);
    var elapsed = nowSecs - REMAINING_CONFIG.startUnix;
    if (elapsed < 0) return REMAINING_CONFIG.start;
    var decrements = Math.floor(elapsed / REMAINING_CONFIG.decrementSeconds);
    var cyclePos = decrements % REMAINING_CONFIG.start;
    return REMAINING_CONFIG.start - cyclePos;
  }

  function updateRemainingText() {
    var liveValue = computeRemaining();
    // Tree-walk so we only rewrite raw text nodes (preserves surrounding markup/styles)
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue || '';
      // Match "Only 25 remaining" / "only 24 remaining" etc.
      if (/only\s+\d+\s+remaining/i.test(t)) {
        node.nodeValue = t.replace(/(only\s+)\d+(\s+remaining)/gi, '$1' + liveValue + '$2');
      }
    }
  }

  function initRemainingCountdown() {
    // Run immediately, then retry after marquee clones its children.
    // We avoid a MutationObserver here because observing + rewriting text
    // risks an infinite loop (we'd trigger our own observer).
    updateRemainingText();
    setTimeout(updateRemainingText, 400);
    setTimeout(updateRemainingText, 1200);
    setTimeout(updateRemainingText, 3000);
    // Refresh once per minute in case the marquee eventually recycles.
    setInterval(updateRemainingText, 60000);
  }

  function init() {
    initStickyATC();
    initPreorderCounter();
    initRemainingCountdown();
    // Exit intent popup \u2014 DISABLED. Re-enable by uncommenting the line below.
    // setTimeout(initExitIntent, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
